import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowUnlimitedRecordings() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.unlimited-recordings')}
      titleSeparator=""
      description={t('feature-description.unlimited-recordings')}
    >
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
